export default {
	'api.baseUri': process.env.VUE_APP_API_BASE_URL,
	'web.mainUri': process.env.VUE_APP_MAIN_URL,
};
